/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';
import { SignupFormComponent } from '../signup-form/signup-form.component';

@Component({
  selector: 'ptl-v3-signup-form',
  templateUrl: './v3-signup-form.component.html',
  styleUrls: ['./v3-signup-form.component.scss'],
})
export class V3SignupFormComponent extends SignupFormComponent {}
